import gql from 'graphql-tag';

export default gql(`
	query server {
		server {
			server_time
			server_timezone
			server_utc_offset
		}
	}
`);

